import React, {useState, useEffect} from "react";
import classNames from "classnames/bind";
import { useSpring, animated } from "react-spring";

import {useStateManager} from "utils/useStateManager";
import {Button} from "../Button";

import styles from "./FrequencyList.module.css";

const cx = classNames.bind(styles);

type Props = {
  items: {
    key: string;
    custom_частота: string;
  }[];
  onSubmit: () => void;
  onChange: (key: string) => void;
  activeKey?: string;
  setShowFrequencyWindow: React.Dispatch<React.SetStateAction<boolean>>;
  isFormSubmitting: boolean;
};

export const FrequencyList = React.forwardRef<HTMLDivElement, Props>(
  ({items, onSubmit, onChange, activeKey, setShowFrequencyWindow, isFormSubmitting}, ref) => {
    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
      setShowAnimation(true);
    }, []);

    const listSpring = useSpring({
      transform: showAnimation ? "translateY(0)" : "translateY(100%)",
      config: { duration: 300},
    });

    return (
      <div
        className={cx("container")}
        ref={ref}
        onClick={() => setShowFrequencyWindow(false)}
      >
        <animated.ul
          className={cx("items")}
          onClick={(e: React.MouseEvent<HTMLUListElement, MouseEvent>) => e.stopPropagation()}
          style={listSpring}
        >
          <li className={cx("item")}>
            <Button
              color="dark"
              type="submit"
              size="medium"
              onClick={() => {
                onSubmit();
                setShowFrequencyWindow(false)
              }}
              isLoading={isFormSubmitting}
              disabled={isFormSubmitting}
            >
              Никогда/очень редко
            </Button>
          </li>
          {items.map((frequency) => (
            <li className={cx("item")}>
              <Button
                key={frequency.key}
                color={activeKey === frequency.key ? "cerulean" : "dark"}
                type="button"
                size="medium"
                onClick={() => {
                  onChange(frequency.key)
                  setShowFrequencyWindow(false)
                }}
                disabled={isFormSubmitting}
              >
                {frequency.custom_частота}
              </Button>
            </li>
          ))}
        </animated.ul>
      </div>
    );
  }
);
